var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6225 9.75691L28.2431 1.37941C27.9646 1.10076 27.6338 0.879722 27.2698 0.728915C26.9058 0.578108 26.5156 0.500488 26.1216 0.500488C25.7276 0.500488 25.3374 0.578108 24.9734 0.728915C24.6093 0.879722 24.2786 1.10076 24 1.37941L0.87939 24.5C0.599602 24.7776 0.377778 25.108 0.226813 25.4721C0.0758491 25.8361 -0.00124395 26.2265 1.5178e-05 26.6207V35C1.5178e-05 35.7957 0.316086 36.5587 0.878695 37.1214C1.4413 37.684 2.20437 38 3.00002 38H34.5C34.8978 38 35.2794 37.842 35.5607 37.5607C35.842 37.2794 36 36.8979 36 36.5C36 36.1022 35.842 35.7207 35.5607 35.4394C35.2794 35.1581 34.8978 35 34.5 35H15.6225L36.6225 14C36.9012 13.7214 37.1222 13.3907 37.273 13.0267C37.4238 12.6627 37.5014 12.2725 37.5014 11.8785C37.5014 11.4844 37.4238 11.0943 37.273 10.7303C37.1222 10.3662 36.9012 10.0355 36.6225 9.75691ZM8.87252 31.25L24.75 15.3707L27.8794 18.5L12 34.3794L8.87252 31.25ZM6.75002 29.1294L3.62064 26L19.5 10.1207L22.6294 13.25L6.75002 29.1294ZM3.00002 29.6207L8.37939 35H3.00002V29.6207ZM30 16.3794L21.6225 8.00003L26.1225 3.50004L34.5 11.8794L30 16.3794Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkEdit);
export default __webpack_public_path__ + "static/media/LinkEdit.4baa90c43bfff8c62907d25e4c81bcf9.svg";
export { ForwardRef as ReactComponent };